const INCIDENT_FIELDS = {
  SEQUENCE_NUMBER: 'II_SequenceNumber',
  INCIDENT_NUMBER: 'II_IncidentNumber',
  INCIDENT_DATE: 'II_IncidentDate',
};

export default INCIDENT_FIELDS;
